// src/hooks/useDashboard.ts
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { DashboardService } from '../admin/pages/dashboard/dashboardService';

export const DASHBOARD_KEYS = {
  all:  ['dashboard'] as const,
  data: () => ['dashboard', 'data'] as const,
};

// 5 minutes — dashboard is expensive (full collection reads + warehouse inventory),
// so we hold the cache longer than paginated admin lists.
const DASHBOARD_STALE_TIME = 1000 * 60 * 5;

export const useDashboardData = () => {
  return useQuery({
    queryKey: DASHBOARD_KEYS.data(),
    queryFn: () => DashboardService.getDashboardData(),
    staleTime: DASHBOARD_STALE_TIME,
    // Keep previous data visible while a background refetch runs so the
    // dashboard never shows a blank/loading state on re-visits.
    placeholderData: (prev: any) => prev,
  });
};

export const useRefreshDashboard = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: DASHBOARD_KEYS.all });
};